import { render } from "./InventarioFacil.vue?vue&type=template&id=bce1e214&scoped=true"
import script from "./InventarioFacil.vue?vue&type=script&lang=js"
export * from "./InventarioFacil.vue?vue&type=script&lang=js"

import "./InventarioFacil.vue?vue&type=style&index=0&id=bce1e214&scoped=true&lang=css"

import exportComponent from "/home/frog/Documents/vue/AeAAppDev/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce1e214"]])

export default __exports__